import { render, staticRenderFns } from "./BgcAuditTrailList.vue?vue&type=template&id=390c59fb&scoped=true&"
import script from "./BgcAuditTrailList.vue?vue&type=script&lang=js&"
export * from "./BgcAuditTrailList.vue?vue&type=script&lang=js&"
import style0 from "./BgcAuditTrailList.vue?vue&type=style&index=0&id=390c59fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c59fb",
  null
  
)

export default component.exports